<style>
.notice {
    background-color: rgb(255, 206, 116);
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 30px;
    margin-top: 0px;
}

.box {
    padding: 10px;
    margin-left: -10px;
    border-bottom: 1px solid whitesmoke;
    cursor: pointer;
    color: rgb(0,100,200);
}

.box:hover {
    background-color: whitesmoke;
}

.upcoming {
    color: grey;
}

.upcoming:hover {
    cursor: default;
}
</style>

<script>
import {onMount} from 'svelte'
import {push} from './pt-router/Router.svelte'
import * as Common from './Common.js'
import AreaRequestWidget from './Business/AreaRequestWidget.svelte'
import Spinner from './Spinner.svelte'
import FeaturedAreas from './FeaturedAreas.svelte'

let areas = null
let featuredAreas = []
let upcomingAreas = []

onMount(async () => {
    Common.getData('areas/enabled')
    .then(data => {
        areas = data
    })

    Common.getData('areas/upcoming')
    .then(data => {
        upcomingAreas = data
    })

    Common.getData('areas/featured')
    .then(data => {
        console.log(data)
        featuredAreas = data.sort((a,b) => {
            return a.id > b.id;
        }).slice(0,4)
    })
})

</script>

<div>
    <h1>Featured Areas</h1>
    <FeaturedAreas areas={featuredAreas}></FeaturedAreas>

    <h1>All Areas</h1>
    {#if areas===null}
        <Spinner></Spinner>
    {:else if areas.length===0}
        <p>No areas in system.</p>
    {:else}
        {#each areas as area}
            <div class="box" on:click={() => push('/area/' + area.id)}>
                {area.name}, {area.country} {#if area.verified}(Official){/if}
            </div>
        {/each}
    {/if}

    {#if upcomingAreas.length != 0}
        <h1>Coming Soon</h1>
        {#each upcomingAreas as area}
            <div class="box upcoming">
                {area.name}, {area.country} ({Common.UnixTimeToDateOnlyStr(area.enabledate)})
            </div>
        {/each}
    {/if}
</div>